import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Icon from "@material-ui/core/Icon";
import Collapse from "@material-ui/core/Collapse";
// core components
import SidebarLinks from "./SideBarLink";
import DesktopHeader from "../Header/DesktopHeader";
import brandTheme from "brandTheme/Theme";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
const useStyles = makeStyles(({ theme }) => ({
  itemIcon: {
    width: "24px",
    height: "30px",
    fontSize: "24px",
    lineHeight: "30px",
    float: "left",
    marginRight: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: brandTheme.black,
  },
  itemText: {
    fontFamily: brandTheme.font.poppins,
    fontWeight: "bold",
    margin: "0",
    lineHeight: "30px",
    fontSize: "14px",
    color: brandTheme.black,
    "&:hover": {
      fontSize: "18px",
    },
  },
  sidebarWrapper: {
    position: "relative",
    width: "260px",
  },
  dashboardMenu: {
    backgroundColor: brandTheme.sideBarColor,
    fontWeight: "bold",
    fontFamily: brandTheme.font.poppins,
    fontSize: "18px",
    marginBottom: "8px",
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
      fontSize: "20px",
    },
  },
  item: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    backgroundColor: brandTheme.sideBarColor,

    "&:focus,&:visited,&": {
      color: brandTheme.black,
    },
    "&:hover": {
      backgroundColor: brandTheme.sideBarHoverColor,
    },
  },
  activeClass: {
    position: "relative",
    marginBottom: "8px",
    display: "block",
    textDecoration: "none",
    backgroundColor: brandTheme.sideBarHoverColor,
  },
  children: {
    "& $activeClass": {
      paddingLeft: 35,
    },
    "& $item": {
      paddingLeft: 35,
    },
  },
}));

const SideBar = ({ handleDrawerToggle, open }) => {
  const [itemState, setItemState] = useState({});
  const [masterOpen, setMasterOpen] = useState(true);
  const [activeLink, setActiveLink] = useState("/coreservice/core-dashboard");
  const [callInProgress, setCallInProgress] = useState(false);
  const classes = useStyles();
  const { authToken } = useSelector((state) => state.login.authData);
  const [rawData, setRawData] = useState([]);
  const [ColleralValuationTabName, setColleralValuationTabName]=useState("")
  const parseAndSetFlag = (flag) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    return parsedFlag;
  };
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const getFeatureFlag = async () => {
    setCallInProgress(true)
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    setCallInProgress(false)
    const designationOrRoleBased = parseAndSetFlag(
      result?.data?.showTabsAsPerTheDesignationFlag
    );
    setColleralValuationTabName(result?.data?.changeColleteralEvaluationTabName)
    if (designationOrRoleBased || !designationOrRoleBased) {
      await getUserDetails(
        designationOrRoleBased,
        result?.data?.removeLosMasterListCodes
      );
    }
  };
  function filterSidebarItems(items, enabledCodes) {
    return items
      ?.map((item) => {
        const isAllowed = enabledCodes.has(item.code);

        // Recursively filter children if any
        const filteredChildren = item.children
          ? filterSidebarItems(item.children, enabledCodes)
          : [];

        if (isAllowed || filteredChildren.length > 0) {
          return {
            ...item,
            children:
              filteredChildren.length > 0 ? filteredChildren : undefined,
          };
        }

        return null;
      })
      .filter(Boolean);
  }
  const parseCodeArray = (input) => {
    if (Array.isArray(input)) return input;

    if (typeof input === "string") {
      try {
        const jsonReady = input.replace(/'/g, '"');
        return JSON.parse(jsonReady);
      } catch (e) {
        console.error("Failed to parse codesToRemove:", input, e);
        return [];
      }
    }

    return [];
  };
  const getUserDetails = async (designationOrRoleBased, removedList) => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.USER_DETAIL,
      authToken: authToken,
    });
    setCallInProgress(false);
    const finalUser = result?.data?.role === "role_checker" && !result?.data?.rootHierarchy
    ? "role_branch_checker"
    : result?.data?.role;
    const searchParam = designationOrRoleBased
      ? result?.data?.designation
      : finalUser;
    GetData(searchParam, designationOrRoleBased, removedList);
  };
  const GetData = async (searchParam, designationOrRoleBased, removedList) => {
    setCallInProgress(true);
    const query = designationOrRoleBased
      ? `designation=${searchParam}`
      : `role=${searchParam}`;
    const result = await apiHandler({
      url: endpoint.UI_RESTRICTION_FIND + query,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code || result?.data?.user_description) {
      removedList = parseCodeArray(removedList);
      const codeSet = new Set(removedList?.map((code) => code.trim()));
      const filtered = [];

      for (const [, value] of Object.entries(SidebarLinks)) {
        const code = value?.code?.trim();
        if (codeSet.has(code)) continue;

        const newItem = { ...value };

        if (value.children) {
          const filteredChildren = Object.values(value.children).filter(
            (child) => {
              const childCode = child?.code?.trim();
              return !codeSet.has(childCode);
            }
          );

          if (filteredChildren.length > 0) {
            newItem.children = filteredChildren;
          } else {
            delete newItem.children;
          }
        }

        filtered.push(newItem);
      }

      setRawData(filtered);
    } else {
      const removeListFromFlag = parseCodeArray(removedList);
      const losListData = JSON.parse(result?.data?.restrictions);

      const enabledCodes = new Set(
        losListData?.los
          ?.filter((item) => !item.disabled)
          .map((item) => item.code)
      );
      let finalRenderList = filterSidebarItems(SidebarLinks, enabledCodes);
     const hiddenCodes = new Set(removeListFromFlag.map(code => code.trim()));
      finalRenderList = finalRenderList
        .map((item) => {
          if (!item.children) return item;
          const children = item.children.filter(
            (child) => !hiddenCodes.has(child.code?.trim())
          );
          return {
            ...item,
            children,
          };
        })
        .filter((item) => {
          if (hiddenCodes.has(item.code?.trim())) {
            return false;
          }
          if (item.children && item.children.length === 0) {
            return false;
          }
          return true;
        });

setRawData(finalRenderList);
      sessionStorage.setItem(
        "sideBarData",
        JSON.stringify({ losListData: losListData?.los })
      );
    }
  };
  const handler = (children) => {
    return children.map((subOption) => {
      if (!subOption.children) {
        return (
          <NavLink
            to={subOption.url}
            className={
              subOption.url === activeLink ? classes.activeClass : classes.item
            }
            // activeClassName="active"
            key={subOption.name}
          >
            <ListItem button>
              {typeof subOption.icon === "string" ? (
                <img
                  src={subOption.icon}
                  alt={""}
                  className={classNames(classes.itemIcon)}
                ></img>
              ) : (
                <subOption.icon className={classNames(classes.itemIcon)} />
              )}
              <ListItemText
                primary={subOption?.name=== "Collateral Valuation Approval" ? ColleralValuationTabName : subOption?.name}
                className={classNames(classes.itemText)}
                disableTypography={true}
                onClick={() => setActiveLink(subOption.url)}
              />
            </ListItem>
          </NavLink>
        );
      }
      return (
        <div key={subOption.name}>
          <ListItem
            className={classes.dashboardMenu}
            button
            onClick={() => handleClick(subOption.name)}
          >
            {typeof subOption.icon === "string" ? (
              <img
                src={subOption.icon}
                alt={""}
                className={classNames(classes.itemIcon)}
              ></img>
            ) : (
              <subOption.icon className={classNames(classes.itemIcon)} />
            )}
            <ListItemText
              primary={subOption.name}
              disableTypography={true}
              className={classNames(classes.itemText)}
            />
            {masterOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={masterOpen} timeout="auto" className={classes.children}>
            {handler(subOption.children)}
          </Collapse>
        </div>
      );
    });
  };

  const handleClick = (item) => {
    let is = itemState;
    is[item] = !itemState[item];
    setItemState(is);
    setMasterOpen(!masterOpen);
  };
  return (
    <div>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <div className={classes.sidebarWrapper}>
            {<DesktopHeader />}
            {handler(rawData)}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown implementation="css">
        <div className={classes.sidebarWrapper}>{handler(rawData)}</div>
      </Hidden>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

SideBar.propTypes = {
  handleDrawerToggle: PropTypes.func,
  open: PropTypes.bool,
};

export default SideBar;